<template>
  <div v-if="asset">
    <PlayBtn class="h-8" @click="handleRoutinePlay">{{ $t('exercises.playRoutine') }}</PlayBtn>
    <Modal :showing="showing" fullscreen :min-width="true" @close="showing = false">
      <CraftAsset :asset="asset" :autoplay="true" class="w-full" />
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal'
import CraftAsset from '@/components/common/CraftAsset'
import PlayBtn from '@/components/common/PlayBtn'
import Routine from '@/mixins/Routine'

export default {
  components: {
    PlayBtn,
    CraftAsset,
    Modal
  },
  mixins: [Routine],
  props: {
    asset: {
      type: Object,
      default: () => null
    },
    routine: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showing: false
    }
  },
  methods: {
    handleRoutinePlay() {
      this.showing = true
      const routineData = {
        event: 'gaEvent',
        event_name: 'routine_execution',
        routine_execution: {
          routine_name: this.routine.title,
          sport: this.parseExerciseProperties(this.routine.sports),
          training_goal: this.parseExerciseProperties(this.routine.trainingGoals),
          difficulty: this.parseExerciseProperties(this.routine.difficulty),
          routine_duration: this.routine.duration,
          products: this.parseExerciseProperties(this.routine.products),
          event_category: 'Routine',
          event_action: 'Execution',
          event_label: this.routine.title
        }
      }
      this.$_gtm.push(routineData)
    }
  }
}
</script>
